import {
	ArrowBack as ArrowBackIcon,
	Groups as GroupsIcon,
	Person as PersonIcon,
} from '@mui/icons-material'

import { Divider } from '@mui/material'

import {
	formatConversationPreview,
	formatPhoneNumber,
	formatTimestampLabel,
} from '../../services/scout'

import ConversationAvatar from './ConversationAvatar'

const ConversationSidebar = ({
	selectedAccount,
	selectedAccountAvatarClassName,
	filteredConversations,
	selectedConversationId,
	selectConversation,
	handleBackNavigation,
	getStableConversationTitle,
}) => {
	return (
		<aside className="scout-panel scout-panel--sidebar scout-conversations-sidebar">
			<div style={{ padding: '1rem' }}>
				<button
					type="button"
					className="scout-back-link"
					onClick={handleBackNavigation}
				>
					<ArrowBackIcon />
					<span>Voltar</span>
				</button>

				{selectedAccount ? (
					<div className="scout-account-hero">
						<ConversationAvatar
							conversation={selectedAccount}
							displayName={selectedAccount?.name || 'Conta'}
							className={selectedAccountAvatarClassName}
						/>
						<div>
							<strong>{selectedAccount.name}</strong>
							<span>{formatPhoneNumber(selectedAccount.phone_number)}</span>
						</div>
					</div>
				) : null}
			</div>

			<Divider />

			<div className="scout-conversation-list">
				{filteredConversations.map((conversation) => {
					const selected = conversation.id === selectedConversationId

					return (
						<button
							key={conversation.id}
							type="button"
							className={selected ? 'scout-conversation-row scout-conversation-row--selected' : 'scout-conversation-row'}
							onClick={() => selectConversation(conversation.id)}
						>
							{conversation.type === 'CONTACT' ? <PersonIcon /> : <GroupsIcon />}
							<ConversationAvatar conversation={conversation} displayName={getStableConversationTitle(conversation)} />
							<div className="scout-conversation-row__body">
								<strong>{getStableConversationTitle(conversation)}</strong>
								<span>{formatConversationPreview(conversation)}</span>
								<small>{formatTimestampLabel(conversation.last_message_timestamp)}</small>
							</div>
						</button>
					)
				})}
			</div>
		</aside>
	)
}

export default ConversationSidebar